<template>
  <div class="modal_history">
    <div class="content">
      <div class="response_table">
        <table>
          <thead style="height: 50px; flex:0; display: inline-block">
            <tr>
              <th scope="col">
                {{ translate('sim_server.history.device_id') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.history.action') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.history.comment') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.history.user_name') }}
              </th>
              <th scope="col">
                {{ translate('sim_server.history.ts_action') }}
              </th>
            </tr>
          </thead>
            <tbody>
              <tr v-for="(action, key) in actions_history" :key="key">
                <td :data-label="translate('sim_server.history.device_id')">
                  {{ action.device_id }}
                </td>
                <td :data-label="translate('sim_server.history.action')">
                  {{ action.action }}
                </td>
                <td :data-label="translate('sim_server.history.comment')">
                  {{ action.comment }}
                </td>
                <td :data-label="translate('sim_server.history.user_name')">
                  {{ action.userName }}
                </td>
                <td :data-label="translate('sim_server.history.ts_action')">
                  {{ get_date(action.ts_action) }}
                </td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: "ActionsHistory",
  props: ['actions_history'],
  data() {
    return {

    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
.modal_history {
  width: 100%;
  color: #252422;
  position: relative;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    .title {
      margin-top: 15px;
    }
  }
}

.response_table {
  padding: 0;

  table {
    .has_service {
      background-color: #41b88330;
    }

    .status {
      width: 40px;
      vertical-align: middle;
    }

    .active {
      width: 70px;
    }

    tbody {
      .link {
        color: black;
      }
    }
  }

  table tr {
    background-color: white;

    &:hover {
      background-color: #f1f1f1;
    }
  }
}
</style>
